import { CustomTheme } from '../../../lib/utils/CustomTheme';
const { desktop } = CustomTheme.mediaQueries;
export const headerWrapper = {
    padding: '1.5rem', // 24px to rem
    borderRadius: '0 0 1.25rem 1.25rem', // 20px to rem
    display: 'flex',
    gap: '0.625rem',
    flexDirection: 'column',
    backgroundColor: CustomTheme.container.primary,
    [desktop]: {
        padding: '2.5rem', // 40px to rem
        paddingBottom: 0,
        gap: '1.5rem', // 24px to rem
    },
};
